module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-latin244.9564838.woff2";